import { documentTypes } from './documents.const'

const POLICIES = {
  // public: 'general_public',
  // private: 'general_private'
  public: 'alpha', // general_public
  private: 'bravo' // general_private
}

export const DOCUMENT_POLICIES = Object.freeze({
  [documentTypes.kycIdDocument]: POLICIES.private,
  [documentTypes.kycProofOfAddress]: POLICIES.private,
  [documentTypes.kycSelfie]: POLICIES.private,
  [documentTypes.fundLogo]: POLICIES.public,
  [documentTypes.fundDocument]: POLICIES.public,
  [documentTypes.navReport]: POLICIES.public,
  [documentTypes.syndicate_member_photo]: POLICIES.public,
  [documentTypes.bravo]: POLICIES.public,
  [documentTypes.charlie]: POLICIES.public,
  [documentTypes.delta]: POLICIES.public,
  [documentTypes.tokenTerms]: POLICIES.public,
  [documentTypes.tokenLogo]: POLICIES.public,
  [documentTypes.tokenMetrics]: POLICIES.public,
  [documentTypes.kycTaxIdentification]: POLICIES.private,
  [documentTypes.kycTaxReturns]: POLICIES.private,
  [documentTypes.kycPersonalIncome]: POLICIES.private,
  [documentTypes.kycJointIncome]: POLICIES.private,
  [documentTypes.kycPriorPersonalIncome]: POLICIES.private,
  [documentTypes.kycPriorJointIncome]: POLICIES.private,
  [documentTypes.kycNetWorth]: POLICIES.private,
  [documentTypes.kycEstateNetValue]: POLICIES.private,
  [documentTypes.kycLiquidAssets]: POLICIES.private,
  [documentTypes.kycOtherAssets]: POLICIES.private,
  [documentTypes.kycOriginationCertificate]: POLICIES.private,
  [documentTypes.kycInvestmentPresentation]: POLICIES.private,
  [documentTypes.kycManagementBios]: POLICIES.private,
  [documentTypes.kycManagementCvs]: POLICIES.private,
  [documentTypes.kycManagementPictures]: POLICIES.private,
  [documentTypes.kycProofOfInvestor]: POLICIES.private,
  [documentTypes.kycShareholdersCertificate]: POLICIES.private,
  [documentTypes.kycAnnualReport]: POLICIES.private,
  [documentTypes.kycMemorandium]: POLICIES.private,
  [documentTypes.kycSignatoriesAuthorization]: POLICIES.private,
  [documentTypes.kycOrganizationChart]: POLICIES.private,
  [documentTypes.kycBusinessModel]: POLICIES.private,
  [documentTypes.tokenIcon]: POLICIES.public,
  [documentTypes.limitsProofOfIncome]: POLICIES.private,
  [documentTypes.contract]: POLICIES.public,
  [documentTypes.invoice]: POLICIES.public,
  [documentTypes.dispute]: POLICIES.public
})



// WEBPACK FOOTER //
// ./src/js/const/document-policies.const.js